const getFormattedDateTime = (date) => {
    var now = new Date(date) || new Date();
    
    var month = (now.getMonth() + 1).toString().padStart(2, '0');
    var day = now.getDate().toString().padStart(2, '0');
    var year = now.getFullYear().toString();
    
    var hours = now.getHours();
    var minutes = now.getMinutes().toString().padStart(2, '0');
    var amPm = hours >= 12 ? 'PM' : 'AM';
    
    if (hours > 12) {
      hours -= 12;
    } else if (hours === 0) {
      hours = 12;
    }
    
    var formattedDateTime = month + '/' + day + '/' + year + ' ' + hours + ':' + minutes + ' ' + amPm;
    return formattedDateTime;
}

export default getFormattedDateTime;


export const convert12To24 = (hour12) => {
  let [time, period] = hour12.split(' ');
  let [hours, minutes, seconds = "00"] = time.split(':').map(Number);

  if (period === 'PM' && hours !== 12) {
      hours += 12;
  } else if (period === 'AM' && hours === 12) {
      hours = 0;
  }

  return `${String(hours).padStart(2, '0')}:${String(minutes).padStart(2, '0')}:${String(seconds).padStart(2, '0')}`;
}
export const convert24To12 = (hour24) => {
  let [hours, minutes, seconds] = hour24.split(':').map(Number);

  let period = hours >= 12 ? 'PM' : 'AM';
  hours = hours % 12 || 12;

  // return `${String(hours).padStart(2, '0')}:${String(minutes).padStart(2, '0')}:${String(seconds).padStart(2, '0')} ${period}`;
  return `${String(hours).padStart(2, '0')}:${String(minutes).padStart(2, '0')} ${period}`;
}

export const isDateGreatThenToday = (startDate) => {
  startDate = new Date(startDate);
  const today = new Date();
  // startDate = new Date("2026-05-16");
  // const today = new Date("2026-05-17");

  // Reset time to midnight so you compare dates only, not times
  startDate.setHours(0, 0, 0, 0);
  today.setHours(0, 0, 0, 0);

  if (startDate.getTime() > today.getTime()) {
    return true;
  } else {
    return false;
  }
};